
export type FoodType = 'normal'|'double'|'shrink'|'speed'|'slow'|'life'|'hunger';

export class Food {
  expiration = -1;
  constructor(public x = 0, public y = 0, public type: FoodType) {}
}
